module.exports = __webpack_public_path__ + "static/img/ver-3.5e86560b.png";